import Box from '@cloudscape-design/components/box';
import Link from '@cloudscape-design/components/link';
import { FilterPreset } from '../hooks/useTicketFilters';
import { recordEvent } from '../rum';

interface PopularSearchesProps {
  onPreset: (preset: FilterPreset) => void;
}

const PRESETS: { key: FilterPreset; label: string }[] = [
  { key: 'myTickets', label: 'My Tickets' },
  { key: 'highSev', label: 'High-Sev' },
  { key: 'stale', label: 'Stale' },
  { key: 'thisWeek', label: 'This Week' },
  { key: 'unassigned', label: 'Unassigned' },
];

export function PopularSearches({ onPreset }: PopularSearchesProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
      <Box variant="p" fontWeight="bold" color="text-body-secondary">
        Popular Searches:
      </Box>
      {PRESETS.map((preset, i) => (
        <span key={preset.key} style={{ display: 'inline-flex', alignItems: 'center', gap: '10px' }}>
          <Link
            variant="secondary"
            fontSize="body-m"
            onFollow={(e) => { e.preventDefault(); recordEvent('filter_apply', { preset: preset.key }); onPreset(preset.key); }}
          >
            {preset.label}
          </Link>
          {i < PRESETS.length - 1 && (
            <span style={{ color: '#b0b8c4' }}>|</span>
          )}
        </span>
      ))}
    </div>
  );
}
